<template>
  <div>
    <custom-callout :has-toggle="false" border-color="gray" class="mt-3">
      <div class="row">
        <div
          :class="['col-12 pl-2', { 'p-2 pr-3': isMobile, 'p-3': !isMobile }]"
        >
          <div class="row">
            <div :class="['col-12 col-md-2 pt-0', { 'ml-4': !isMobile }]">
              <div :class="{ 'divider-horizontal': !isMobile }">
                <div class="row">
                  <div :class="['col-12 pt-0', { 'pl-0': !isMobile }]">
                    <strong class="text-title">{{ item.number }}</strong>
                    <div class="regular text-black">
                      {{ item.title }}
                    </div>
                  </div>
                  <div v-show="isMobile" class="col-12 pr-4 pt-3 pb-2">
                    <div class="divider-vertical" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-9">
              <div class="row">
                <div class="col-6 col-md-2 pt-0">
                  <span class="text-title-mobile">Categoría:</span>
                  <div class="regular text-black">
                    {{ item.category.name }}
                  </div>
                </div>
                <div class="col-6 col-md-2 pt-0">
                  <span class="text-title-mobile">Creado:</span>
                  <div class="regular text-black">
                    {{ item.createdByFullName }}
                  </div>
                  <div class="regular text-black">
                    {{ formatDate(item.createdDate) }}
                  </div>
                </div>
                <div class="col-6 col-md-2 pt-0">
                  <span class="text-title-mobile">Modificado:</span>
                  <div class="regular text-black">
                    {{ item.modifyByFullName }}
                  </div>
                  <div class="regular text-black">
                    {{ formatDate(item.modifydDate) }}
                  </div>
                </div>
                <div class="col-6 col-md-2 pt-0 mt-2">
                  <div>
                    <span v-if="userCanAddEdit">
                      <span
                        :class="[
                          'badge badges ' + getBadgeClass(item.isActive),
                          { 'w-100': isMobile },
                        ]"
                      >
                        {{ item.isActive ? 'Activo' : 'Inactivo' }}
                      </span>
                    </span>
                  </div>
                </div>
                <div :class="['col-12 col-md-2 pt-0', { 'pt-2': isMobile }]">
                  <span class="text-title-mobile">Expira:</span>
                  <div class="regular text-black">
                    {{ formatDate(item.expireDate) }}
                  </div>
                </div>
                <div :class="['col-12 col-md-2', { 'pr-4 pt-4': isMobile }]">
                  <drop-down
                    v-if="userCanAddEdit"
                    :items="getActions()"
                    :title="'Acciones'"
                  />
                  <ActionButton
                    v-if="!userCanAddEdit"
                    :class="['downloadButton']"
                    variant="custom-btn-return m-2 text-green"
                    i="fas fa-download"
                    @click="downloadForm()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import moment from 'moment';
import formManagementApi from '@/modules/operation-form-management/api.js';
import mixWait from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';
import documentsService from '@/services/documents';
import DropDown from 'dropdown';
import ActionButton from 'ActionButton';

const EDIT_FORM_ROUTE_NAME = 'CreateEditForm';

export default {
  name: 'ResultRow',
  mixins: [mixWait, alert],
  components: {
    CustomCallout,
    DropDown,
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  computed: {
    userCanAddEdit() {
      return this.$store.getters.HasPermission('form.management');
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    getBadgeClass(status) {
      if (status) {
        return 'badge-active';
      } else {
        return 'badge-inactive';
      }
    },
    editForm() {
      this.$router.push({
        name: EDIT_FORM_ROUTE_NAME,
        params: {
          id: this.item.id,
        },
      });
    },
    downloadForm() {
      formManagementApi
        .downloadForm(this.item)
        .then((response) => {
          documentsService.Download(response.data);
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    formatDate(date) {
      if (date == null) return;
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY')
        .replace('.', '');
    },
    getActions() {
      return [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import text-green pr-1',
          click: () => this.editForm(),
        },
        {
          label: 'Descargar',
          icon: 'fas fa-download text-green pr-1',
          click: () => this.downloadForm(),
        },
      ];
    },
  },
};
</script>

<style scoped>
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
  height: 100%;
}

span {
  color: #727272;
  font-size: 14px;
  font-weight: 400;
}

.downloadButton {
  border: 1px solid #2db782;
  background-color: transparent !important;
  margin-left: 140% !important;
}

/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: 86px;
  height: 32px;
  line-height: 20px;
  border-radius: 18px;
  padding: 5px;
}

.badge-active {
  background: #9fe8ae;
}

.badge-inactive {
  background: #d5b89a;
}

::v-deep button#dropdownMenuButton {
  background-color: transparent !important;
}

@media only screen and (max-width: 375px) {
  button#dropdownMenuButton,
  .dropdown {
    width: 100% !important;
  }

  .divider-vertical {
    border-bottom: 1px solid #e2e2e2;
  }

  .text-title {
    font-size: 14px !important;
    font-weight: normal !important;
  }
  .text-title-mobile {
    font-size: 12px !important;
  }
  .regular {
    font-size: 12px !important;
  }

  .badges {
    font-size: 12px !important;
    height: 29px;
    width: 76px;
  }
}
</style>
